import { z } from 'zod';
import { CandidateOpportunitySchema } from '@axiom/validation';

export const WarmingModalFormSchema = CandidateOpportunitySchema.pick({
  candidateAvailabilityNotes: true,
  candidateExperienceNotes: true,
  candidateExploringOutsideRoles: true,
  candidatePlannedTimeOffNotes: true,
}).extend({
  experienceIds: z.array(z.string().uuid()),
  hasNoConflictOfInterest: z.boolean().refine(
    val => {
      // we only want to allow the form to be submitted if this checkbox is selected
      return val;
    },
    { message: 'Required' }
  ),
});

export type WarmingModalForm = z.infer<typeof WarmingModalFormSchema>;
